// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './util/rem'
// vue中导出excel表格模板
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

Vue.prototype.$FileSaver = FileSaver //设置全局
Vue.prototype.$XLSX = XLSX //设置全局
// 平滑滚动插件
import smoothscroll from 'smoothscroll-polyfill';
 
import store from './store'
Vue.prototype.$store = store

// kick off the polyfill!
smoothscroll.polyfill();

Vue.config.productionTip = false
Vue.use(element);
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  console.log(to)
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // if (window._hmt) {
  //   if (to.path) {
  //     window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  //   }
  // }
  next()
})

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js